import { getFunctions, httpsCallable } from 'firebase/functions'

export async function setUserClaims(claimsMap) {
  console.log('setUserClaims', claimsMap)
  const functions = getFunctions()
  const setClaims = httpsCallable(functions, 'setUserClaims')
  return await setClaims({ claimsMap })
}
